module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/10 - husicka s predni klizkou.jpg";